/**
 * @desc 修改角色
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.RoleUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.put({
    url: '/web/role/updateRole',
    data,
  });
}

export function mock(
  data: defs.RoleUpdateRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.put({
    url: '/mock/web/role/updateRole',
    data,
  });
}
